import React from 'react';
import { Chip, Paper, TableCell, Theme, styled } from '@mui/material';
import { green, orange, red } from '@mui/material/colors';
import { MuiMenuItem } from 'ui/MenuOn';
import { MuiTable, MuiTableColumnItem, MuiTableScrollItems, MuiTableToolbarItems } from 'ui/table/MuiTable';
import { Campaign, CampaignState } from './models/Campaign';

export function mapCampaignStateToStyles(
    state: CampaignState,
    theme: Theme
): { backgroundColor: string; color: string } {
    switch (state) {
        case CampaignState.STARTED:
        case CampaignState.START_QUEUED:
            return { backgroundColor: green['A700'], color: theme.palette.primary.contrastText };
        case CampaignState.STOP_QUEUED:
        case CampaignState.DRAFTED:
            return { backgroundColor: orange['500'], color: theme.palette.primary.contrastText };
        case CampaignState.STOPPED:
        case CampaignState.START_FAILED:
        case CampaignState.STOP_FAILED:
            return { backgroundColor: red['500'], color: theme.palette.primary.contrastText };
    }
}
const PREFIX = 'CampaignsTable';

const classes = {
    stateChip: `${PREFIX}-stateChip`
};

const StyledMuiTable = styled(MuiTable)(({ theme }) => ({
    [`& .${classes.stateChip}`]: ({ campaign }: { campaign: Campaign }) => ({
        ...mapCampaignStateToStyles(campaign.state, theme),
        fontSize: '0.8rem'
    })
}));

function CampaignStateChip(props: { campaign: Campaign }) {
    return <Chip classes={{ root: classes.stateChip }} label={props.campaign.state} />;
}

interface CampaignsTableProps {
    scroll: MuiTableScrollItems;
    toolbarItems: MuiTableToolbarItems;
    data: Campaign[];
    itemActions: (item: Campaign, index: number) => MuiMenuItem[];
    isLoading: boolean;
}

const columns: MuiTableColumnItem[] = [
    {
        key: 'title',
        label: 'Name'
    },
    {
        key: 'description',
        label: 'Description',
        render: (campaign: Campaign, key: string) => (
            <TableCell align="justify" key={key} size="small" style={{ width: '60%' }}>
                {campaign.description}
            </TableCell>
        )
    },
    {
        key: 'state',
        label: 'State',
        headerProps: {
            align: 'center'
        },
        render: (item: Campaign, key: string) => (
            <TableCell align="center" key={key} size="small">
                <CampaignStateChip campaign={item} />
            </TableCell>
        )
    }
];

export const CampaignsTable: React.FC<CampaignsTableProps> = props => (
    <Paper>
        <StyledMuiTable columns={columns} {...props} />
    </Paper>
);
